import React from "react";
import "../App.css";
import { useSelector } from "react-redux";
import CompletedStatus from "./CompletedStatus";
import ExpiredStatus from "./ExpiredStatus";
import SuccessComponent from "../audit-completion-module/SuccessComponent";

const styles = {
  container: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    height: "100svh",
    backgroundColor: "#ffffff",
  },
  image: {
    maxWidth: "90vw",
    maxHeight: "90vh",
    width: "auto",
    height: "auto",
    animation:
      "fadeInOut 4s ease-in-out infinite, pulse 2s ease-in-out infinite",
  },
  correct: {
    maxWidth: "100vw",
    maxHeight: "100vh",
    width: "auto",
    height: "auto",
    animation:
      "fadeInOut 4s ease-in-out infinite, pulse 2s ease-in-out infinite",
  },
  text: {
    maxWidth: "50vw",
    maxHeight: "20vh",
    width: "auto",
    height: "auto",
    transform: "rotate(6.8deg)",
    // animation:
    //   "fadeInOut 4s ease-in-out infinite, pulse 2s ease-in-out infinite",
  },

  "@keyframes fadeInOut": {
    "0%, 70%": { opacity: 0.9 },
    "50%": { opacity: 1 },
  },
  // Keyframes for the pulse animation
  "@keyframes pulse": {
    "0%": { transform: "scale(1)" },
    "50%": { transform: "scale(1.1)" },
    "100%": { transform: "scale(1)" },
  },
};

const NoAccess = () => {
  const no_access = `${process.env.PUBLIC_URL}/inspection-images/access-denied.png`;
  const link_expired = `${process.env.PUBLIC_URL}/inspection-images/link_expired.gif`;
  const not_found = `${process.env.PUBLIC_URL}/inspection-images/not_found.png`;
  const completed = `${process.env.PUBLIC_URL}/inspection-images/completed.gif`;
  const complete = `${process.env.PUBLIC_URL}/inspection-images/complete.png`;

  const { auditStatus } = useSelector((state) => state.imagesStore);
  return (

    <div style={styles.container}>
      {auditStatus === "Expired !" ? (
        <ExpiredStatus />

      ) : auditStatus === "Audit not Found !" ? (
        <img src={not_found} alt="not_found" style={styles.image} />
      ) : auditStatus === "Already Completed !" ? (

        <SuccessComponent />
      ) : (
        <p>Error</p>
      )}

      <style>{`
        @keyframes fadeInOut {
          0%, 70% { opacity: 0.9; }
          50% { opacity: 1; }
        }

        @keyframes pulse {
          0% { transform: scale(1); }
          50% { transform: scale(1.1); }
          100% { transform: scale(1); }
        }
      `}</style>
    </div>
  );
};

export default NoAccess;
